<template>
  <div
    class="pdf-wrapper"
    style="overflow-x: hidden; overflow-y:hidden; height: 100vh;"
  >
    <iframe width="100%" height="100%" :src="this.url" allowfullscreen />
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: this.$route.query.url,
    };
  },
};
</script>
<style scoped>
.pdf-wrapper {
  padding-top: 62px;
  height: 100vh;
}
@media (min-width: 767px) {
  .pdf-wrapper {
    padding-top: 68px;
  }
}
@media (min-width: 1024px) {
  .pdf-wrapper {
    padding-top: 76px;
  }
}
</style>
